"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EngineStateAccessor = exports.BaseStateAccessor = exports.TranscoderController = exports.CompactorController = exports.InvalidEventIndexError = exports.Controller = exports.SnapshottedTranscoder = exports.TranscoderState = exports.SabertoothError = void 0;
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("underscore"));
var commonEngine = tslib_1.__importStar(require("./engine"));
var common = tslib_1.__importStar(require("./definitions"));
var debug_1 = require("./debug");
// SabertoothError should be used for runtime errors that are expected to be recoverable
// by the client. It will encode the type and reason as serialized JSON.
var SabertoothError = /** @class */ (function (_super) {
    tslib_1.__extends(SabertoothError, _super);
    function SabertoothError(type, reason) {
        var _this = _super.call(this, JSON.stringify({ type: type, reason: reason })) || this;
        _this.name = 'SabertoothError';
        // setPrototypeOf is needed to allow instanceof checks in typescript to work correctly.
        Object.setPrototypeOf(_this, SabertoothError.prototype);
        return _this;
    }
    return SabertoothError;
}(Error));
exports.SabertoothError = SabertoothError;
var TranscoderState = /** @class */ (function (_super) {
    tslib_1.__extends(TranscoderState, _super);
    function TranscoderState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.outStream = [];
        // This maps the _id we find on an incoming event to its position in the
        // legacyEvents stream.
        _this.idToInputIndex = {};
        // Maps _id on input event to start position of its transcoded
        // events in the transcoder's outStream.
        _this.idToOutputIndex = {};
        // Maps _id on input event to the number of events appended to the transcoder's
        // oustream as a result of this event.  This is used to determine the correct
        // state to return for stateAfterEvent
        _this.idToOutputCount = {};
        // Maps transcoded event IDs to their position in the outStream
        _this.outIndexMap = {};
        return _this;
    }
    TranscoderState.prototype.restoreFromSnapshot = function (stateDocument) {
        this.outStream = stateDocument['outStream'];
        this.idToInputIndex = stateDocument['idToInputIndex'];
        this.idToOutputIndex = stateDocument['idToOutputIndex'];
        this.idToOutputCount = stateDocument['idToOutputCount'];
    };
    return TranscoderState;
}(commonEngine.SnapshottedStateEngineStateType));
exports.TranscoderState = TranscoderState;
var SnapshottedTranscoder = /** @class */ (function (_super) {
    tslib_1.__extends(SnapshottedTranscoder, _super);
    function SnapshottedTranscoder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SnapshottedTranscoder.prototype, "outStream", {
        // Need to expose this on the class directly so that we implement
        // the StreamTranscoder interface, but this is actually managed
        // within the state object so it works with rollbacks. This needs
        // to be a dynamic property so that the reference survives
        // rollbacks. The controller will still need to take care to
        // update any dependent engines following a rollback on the transcoder.
        get: function () {
            return this.state.outStream;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SnapshottedTranscoder.prototype, "outIndexMap", {
        get: function () {
            return this.state.outIndexMap;
        },
        enumerable: false,
        configurable: true
    });
    SnapshottedTranscoder.prototype.preProcessEvent = function (event) {
        var eventId = common.idFromEvent(event);
        this.state.idToInputIndex[eventId] = this.idToIndexMap[eventId];
        this.state.idToOutputIndex[eventId] = this.outStream.length;
    };
    SnapshottedTranscoder.prototype.postProcessEvent = function (event) {
        var eventId = common.idFromEvent(event);
        this.state.idToOutputCount[eventId] = this.state.outStream.length - this.state.idToOutputIndex[eventId];
        var originalOutStreamLength = this.state.idToOutputIndex[eventId];
        for (var i = originalOutStreamLength; i < this.state.outStream.length; i++) {
            var outstreamEventId = common.idFromEvent(this.state.outStream[i]);
            this.state.outIndexMap[outstreamEventId] = i;
        }
        _super.prototype.postProcessEvent.call(this, event);
    };
    // This grabs the state of the engine corresponding to the transcoder's view of its nextEventOffset.
    // This is necessary so that the transcoder has the right view of engine state in case of a transcoder
    // rolled back, where the latest engine states are in the future compared to the transcoder
    SnapshottedTranscoder.prototype.currentStateOfEngine = function (engine) {
        // If no events have been processed, we should return the initial state
        if (this.outStream.length === 0) {
            return engine.stateBeforeEvent(0);
        }
        return engine.stateAfterEvent(this.outStream.length - 1);
    };
    // To find the state after a legacy event, we need to consider the case when
    // the legacy event transcodes to 0 sabertooth events, as well as when it transcodes
    // to many legacy events.  To do this we check the number of output events transcoded
    // for this eventId, and grab the state *before* the next sabertooth event which was not
    // transcoded from this base event
    SnapshottedTranscoder.prototype.firstOutputIndexAfterInputEventId = function (eventId) {
        var outputIndex = this.state.idToOutputIndex[eventId];
        var outputCount = this.state.idToOutputCount[eventId];
        return outputIndex + outputCount;
    };
    // Helper functions for transcoder debugging
    SnapshottedTranscoder.prototype._inputEventForOutputIndex = function (eventIndex) {
        for (var eventId in this.state.idToInputIndex) {
            if (this.state.idToOutputIndex[eventId] <= eventIndex &&
                this.state.idToOutputIndex[eventId] + this.state.idToOutputCount[eventId] > eventIndex) {
                return this.baseEvents[this.state.idToInputIndex[eventId]];
            }
        }
        throw new Error('input event index missing output event index');
    };
    SnapshottedTranscoder.prototype._outputEventsForInputIndex = function (eventIndex) {
        var events = [];
        var inputId = common.idFromEvent(this.baseEvents[eventIndex]);
        for (var i = 0; i < this.state.idToOutputCount[inputId]; i++) {
            events.push(this.state.outStream[i + this.state.idToOutputIndex[inputId]]);
        }
        return events;
    };
    return SnapshottedTranscoder;
}(commonEngine.SnapshottedStateEngine));
exports.SnapshottedTranscoder = SnapshottedTranscoder;
var Controller = /** @class */ (function () {
    function Controller() {
    }
    Controller.prototype.pushSerialized = function (serializedEvents) {
        var parsed = JSON.parse(serializedEvents);
        return this.pushBatch(parsed);
    };
    Controller.prototype.pushBatch = function (events, shouldStrictlyCheckUndoRedo) {
        var lastUnchangedIndex = this.outputStream().length - 1;
        for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
            var event_1 = events_1[_i];
            var thisValue = this.push(event_1, shouldStrictlyCheckUndoRedo);
            lastUnchangedIndex = Math.min(lastUnchangedIndex, thisValue);
        }
        return lastUnchangedIndex;
    };
    Controller.prototype.latestState = function () {
        return new this.stateAccessorClass(common.AccessorType.Latest, this);
    };
    Controller.prototype.setDebug = function (setting) {
        return (0, debug_1.setDebug)(setting);
    };
    return Controller;
}());
exports.Controller = Controller;
var InvalidEventIndexError = /** @class */ (function (_super) {
    tslib_1.__extends(InvalidEventIndexError, _super);
    function InvalidEventIndexError(eventIndex) {
        var _this = _super.call(this, "State for ".concat(eventIndex, " was undefined.")) || this;
        _this.name = 'InvalidEventIndexError';
        return _this;
    }
    return InvalidEventIndexError;
}(Error));
exports.InvalidEventIndexError = InvalidEventIndexError;
var CompactorController = /** @class */ (function (_super) {
    tslib_1.__extends(CompactorController, _super);
    function CompactorController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Scratch gives a client a way to send an event through Sabertooth's
        // state engines without committing it to the append-only compactor
        // inStream. Pushing any event through the normal `push` command
        // will clear any events in the scratch buffer before sending
        // the pushed event through.
        _this.scratch = [];
        _this.preScratchTailIndex = undefined;
        // Used for tracking how much of the append-only event
        // stream has been pushed into the compactor, which then
        // lets us more efficiently enforce ordering and deduplication
        // inside updateFromPushPayload
        _this.numberOfEventsPushed = 0;
        return _this;
    }
    // Reflects how many events were actually accepted by compactor. In some contexts,
    // incorrect undos and redos do not error but are ignored by the compactor and not
    // added to the inStream. inStreamLength will always accurately reflect the events
    // that compactor has accepted and is passing to be processed by sabertooth.
    CompactorController.prototype.inStreamLength = function () {
        return this.compactor.inStream.length;
    };
    CompactorController.prototype.clearScratch = function () {
        if (this.scratch.length === 0) {
            return;
        }
        for (var _i = 0, _a = this.engines; _i < _a.length; _i++) {
            var engine = _a[_i];
            engine.rollbackToBeforeEvent(this.preScratchTailIndex + 1);
        }
        this.compactor.clearScratch(this.scratch);
        this.scratch = [];
        this.preScratchTailIndex = undefined;
    };
    CompactorController.prototype.pushToScratch = function (event) {
        if (common.isMetaEvent(event)) {
            throw 'Scratch does not currently support compactor metaevents';
        }
        if (this.preScratchTailIndex === undefined) {
            this.preScratchTailIndex = this.compactor.outStream.length - 1;
        }
        this.scratch.push(event);
        this.compactor.pushForScratch(event);
    };
    CompactorController.prototype.pushBatchToScratch = function (events) {
        for (var _i = 0, events_2 = events; _i < events_2.length; _i++) {
            var event_2 = events_2[_i];
            this.pushToScratch(event_2);
        }
    };
    // Return the event id of the first event in scratch or undefined if there is no scratch.
    CompactorController.prototype.firstScratchEventId = function () {
        if (this.scratch.length === 0) {
            return undefined;
        }
        else {
            return this.scratch[0].id;
        }
    };
    CompactorController.prototype.undoRedoAvailability = function (componentStreamIdentifier) {
        var eventTargetedByUndo = this.compactor.eventTargetedByUndoSubjectToBlacklist(componentStreamIdentifier);
        return {
            undo: eventTargetedByUndo !== undefined,
            undoEvent: eventTargetedByUndo,
            redo: this.compactor.redoIsPossible(componentStreamIdentifier),
        };
    };
    CompactorController.prototype.push = function (event, shouldStrictlyCheckUndoRedo) {
        this.clearScratch();
        this.numberOfEventsPushed++;
        var previousTailIndex = this.compactor.outStream.length - 1;
        var lastUnchangedIndex = Number(this.compactor.push(event, shouldStrictlyCheckUndoRedo !== null && shouldStrictlyCheckUndoRedo !== void 0 ? shouldStrictlyCheckUndoRedo : 'looselyCheckUndoRedo'));
        if (previousTailIndex <= lastUnchangedIndex) {
            return lastUnchangedIndex;
        }
        for (var _i = 0, _a = this.engines; _i < _a.length; _i++) {
            var engine = _a[_i];
            engine.rollbackToBeforeEvent(lastUnchangedIndex + 1);
        }
        return lastUnchangedIndex;
    };
    CompactorController.prototype.pushBatch = function (events, shouldStrictlyCheckUndoRedo) {
        return _super.prototype.pushBatch.call(this, events, shouldStrictlyCheckUndoRedo);
    };
    CompactorController.prototype.stateBeforeEvent = function (eventId) {
        var accessor = new this.stateAccessorClass(common.AccessorType.Before, this);
        accessor.eventIndex = this.compactor.outIndexMap[eventId];
        if (accessor.eventIndex === undefined) {
            throw new common.InvalidStateAccessorError(common.AccessorType.Before, eventId);
        }
        return accessor;
    };
    // eventId is looking up into outStream so should be a play event.
    CompactorController.prototype.stateAfterEvent = function (eventId) {
        var accessor = new this.stateAccessorClass(common.AccessorType.After, this);
        accessor.eventIndex = this.compactor.outIndexMap[eventId];
        if (accessor.eventIndex === undefined) {
            throw new common.InvalidStateAccessorError(common.AccessorType.After, eventId);
        }
        return accessor;
    };
    CompactorController.prototype.stateAfterTimestamp = function (timestamp) {
        var event = findEventBinarySearch(this.compactor.outStream, timestamp);
        if (event) {
            return this.stateAfterEvent(event.id);
        }
        else {
            return new this.stateAccessorClass(common.AccessorType.After, this);
        }
    };
    CompactorController.prototype.eventIdAfterTimestamp = function (timestamp) {
        var event = findEventBinarySearch(this.compactor.outStream, timestamp);
        if (event) {
            return event.id;
        }
        else {
            throw new Error("No event found for timestamp ".concat(timestamp));
        }
    };
    CompactorController.prototype.outputStream = function () {
        return this.compactor.outStream;
    };
    CompactorController.prototype.outputEventById = function (eventId) {
        return this.compactor.outStream[this.compactor.outIndexMap[eventId]];
    };
    CompactorController.prototype.outputEventsById = function (eventIds) {
        return _.map(eventIds, this.outputEventById, this);
    };
    // Need to pass streamEventIds because it is the format required for transcoder
    // This assumes Sabertooth streams are append-only. Additionally, Sabertooth events
    // wrap the "real" data inside an event_data subdocument, so we extract that out before
    // passing it into the engines. This also affects our internal recording of which events
    // have already been passed.
    CompactorController.prototype.updateFromPushPayload = function (streamEventIds, newEvents) {
        var lastUnchangedIndex = this.compactor.outStream.length - 1;
        var newEventsById = {};
        for (var _i = 0, newEvents_1 = newEvents; _i < newEvents_1.length; _i++) {
            var event_3 = newEvents_1[_i];
            newEventsById[common.idFromEvent(event_3)] = event_3;
        }
        for (var i = this.numberOfEventsPushed; i < streamEventIds.length; i++) {
            var nextEventId = streamEventIds[i];
            var newEvent = newEventsById[nextEventId];
            if (newEvent !== undefined) {
                var newEventData = newEvent['event_data'];
                lastUnchangedIndex = Math.min(lastUnchangedIndex, this.push(newEventData, 'looselyCheckUndoRedo'));
            }
            else {
                console.log('WARNING: The controller thinks that event ' +
                    nextEventId +
                    ' is new. But we cannot find it in the newEvents in the push payload. Will not attempt to push any more events');
                break;
            }
        }
        return lastUnchangedIndex;
    };
    CompactorController.prototype.updateFromSerializedPushPayload = function (streamEventIds, serializedNewEvents) {
        // TODO: It might be good to use a deserializer or a type that this parses into.
        var parsed = JSON.parse(serializedNewEvents);
        return this.updateFromPushPayload(streamEventIds, parsed);
    };
    return CompactorController;
}(Controller));
exports.CompactorController = CompactorController;
var TranscoderController = /** @class */ (function (_super) {
    tslib_1.__extends(TranscoderController, _super);
    function TranscoderController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.legacyEvents = [];
        return _this;
    }
    // Push a new or modified event to the input event stream. New events
    // (based on _id) are appended to the stream. Previously-seen events
    // overwrite the first version of that event at the same position in
    // the input stream. Returns the last unchanged index in the transcoder's
    // output stream, which may be -1 if the outStream was previously empty.
    TranscoderController.prototype.push = function (event) {
        // push is our only publicly available method, but we need
        // completely different logic if this is a previously-seen event
        // that is being pushed again because it was modified
        var eventId = common.idFromEvent(event);
        if (eventId !== undefined && this.transcoder.latestState.idToInputIndex[eventId] !== undefined) {
            return this.replaceEventsInLegacyStream([event]);
        }
        var lastUnchangedIndex = this.transcoder.outStream.length - 1;
        this.legacyEvents.push(event);
        this.transcoder.processToLatestEvent();
        return lastUnchangedIndex;
    };
    TranscoderController.prototype.processUndosFromPushPayload = function (streamEventIds) {
        // In undo case, a previously processed event
        // will be missing or replaced (different ID entirely, not modified same event)
        // in the new list of event IDs from the stream.
        var undoIndex = undefined;
        var loopMax = Math.min(streamEventIds.length, this.legacyEvents.length);
        for (var i = 0; i < loopMax; i++) {
            if (streamEventIds[i] !== common.idFromEvent(this.legacyEvents[i])) {
                undoIndex = i - 1; // it's fine that this can be -1, don't freak out
                break;
            }
        }
        if (undoIndex === undefined && streamEventIds.length < this.legacyEvents.length) {
            undoIndex = streamEventIds.length - 1;
        }
        if (undoIndex !== undefined) {
            return this.deleteTailEvents(this.legacyEvents.length - 1 - undoIndex);
        }
        return this.transcoder.outStream.length - 1;
    };
    // Convenience method for updating this controller's transcoder based on the
    // current ordered list of events from a legacy stream and any new events which
    // should be replaced or pushed to the controller. This is meant to line up
    // with the data returned by push.js.
    // TODO: We probably need to handle deletes in the middle of the stream gracefully
    TranscoderController.prototype.updateFromPushPayload = function (streamEventIds, newEvents) {
        // Hack to support transcoder controllers adding initial
        // set_teams events to their input streams. This event will
        // not show up when the client passes down the stream's event
        // list, so we check for auto_generated events at the beginning
        // of the existing transcoder inStream and add them to our streamEventIds.
        if (this.transcoder.baseEvents.length > 0) {
            var headEventId = common.idFromEvent(this.transcoder.baseEvents[0]);
            if (headEventId && headEventId.indexOf('auto_generated') !== -1) {
                streamEventIds.unshift(headEventId);
            }
        }
        var lastUnchangedIndex = this.processUndosFromPushPayload(streamEventIds);
        var newEventsById = {};
        for (var _i = 0, newEvents_2 = newEvents; _i < newEvents_2.length; _i++) {
            var event_4 = newEvents_2[_i];
            newEventsById[common.idFromEvent(event_4)] = event_4;
        }
        var eventsToReplace = [];
        for (var _a = 0, _b = this.legacyEvents; _a < _b.length; _a++) {
            var event_5 = _b[_a];
            var eventId = common.idFromEvent(event_5);
            if (eventId && _.has(newEventsById, eventId)) {
                eventsToReplace.push(newEventsById[eventId]);
            }
        }
        if (eventsToReplace.length !== 0) {
            lastUnchangedIndex = this.replaceEventsInLegacyStream(eventsToReplace);
        }
        for (var i = this.legacyEvents.length; i < streamEventIds.length; i++) {
            var nextEventId = streamEventIds[i];
            var newEvent = newEventsById[nextEventId];
            if (newEvent !== undefined) {
                this.push(newEvent);
            }
            else {
                console.log('WARNING: The controller thinks that event ' +
                    nextEventId +
                    ' is new. But we cannot find it in the newEvents in the push payload. Will not attempt to push any more events');
                break;
            }
        }
        this.transcoder.processToLatestEvent();
        return lastUnchangedIndex;
    };
    TranscoderController.prototype.updateFromSerializedPushPayload = function (streamEventIds, serializedNewEvents) {
        // TODO: It might be good to use a deserializer or a type that this parses into.
        var parsed = JSON.parse(serializedNewEvents);
        return this.updateFromPushPayload(streamEventIds, parsed);
    };
    TranscoderController.prototype.replaceEventsInLegacyStream = function (events) {
        // snapshot controllers rollback (rollbackToBeforeEvent) by changing the state of the global
        // state object. A single level clone here keeps references to the old attributes on the state
        // after the rollbackToBeforeEvent call
        var transcoderStateAtStart = _.clone(this.transcoder.latestState);
        var earliestInputIndex = Infinity;
        var correspondingOutputIndex = 0;
        for (var _i = 0, events_3 = events; _i < events_3.length; _i++) {
            var event_6 = events_3[_i];
            var eventId = common.idFromEvent(event_6);
            var thisInputIndex = transcoderStateAtStart.idToInputIndex[eventId];
            if (thisInputIndex < earliestInputIndex) {
                earliestInputIndex = thisInputIndex;
                correspondingOutputIndex = transcoderStateAtStart.idToOutputIndex[eventId];
            }
        }
        // Rollback transcoder and engines to before the legacy event
        // (input) or its transcoded events (output) were processed
        this.transcoder.rollbackToBeforeEvent(earliestInputIndex);
        var lastUnchangedIndex = this.transcoder.outStream.length - 1;
        // The transcoder just restored its outStream from a snapshot, so
        // the engines lost their reference to the outStream. We need to
        // reset it.
        this.setEngineOutStreamAndIndex(correspondingOutputIndex);
        for (var _a = 0, events_4 = events; _a < events_4.length; _a++) {
            var event_7 = events_4[_a];
            var inputIndex = transcoderStateAtStart.idToInputIndex[common.idFromEvent(event_7)];
            this.legacyEvents.splice(inputIndex, 1, event_7);
        }
        this.transcoder.processToLatestEvent();
        return lastUnchangedIndex;
    };
    // Remove the given number events from the tail of the input stream,
    // rolling back the transcoder and engines.
    TranscoderController.prototype.deleteTailEvents = function (numberToDelete) {
        numberToDelete = Math.min(this.legacyEvents.length, numberToDelete);
        this.legacyEvents.splice(this.legacyEvents.length - numberToDelete, numberToDelete);
        this.transcoder.rollbackToBeforeEvent(this.legacyEvents.length);
        var lastUnchangedIndex = this.transcoder.outStream.length - 1;
        this.setEngineOutStreamAndIndex(this.transcoder.outStream.length);
        return lastUnchangedIndex;
    };
    // For transcoder controllers, the eventId we're given is a legacy event id.
    // So we must lookup the id of the event in the transcoder's outstream (which
    // is the stream of events provided to the engines)
    TranscoderController.prototype.stateBeforeLegacyEvent = function (legacyEventId) {
        var accessor = new this.stateAccessorClass(common.AccessorType.Before, this);
        accessor.eventIndex = this.transcoder.latestState.idToOutputIndex[legacyEventId];
        return accessor;
    };
    TranscoderController.prototype.stateAfterLegacyEvent = function (legacyEventId) {
        var accessor = new this.stateAccessorClass(common.AccessorType.Before, this);
        accessor.eventIndex = this.transcoder.firstOutputIndexAfterInputEventId(legacyEventId);
        return accessor;
    };
    // These operate on Sabertooth IDs in the outStream similar
    // to their compactor counterparts
    TranscoderController.prototype.stateBeforeEvent = function (eventId) {
        var accessor = new this.stateAccessorClass(common.AccessorType.Before, this);
        accessor.eventIndex = this.transcoder.outIndexMap[eventId];
        return accessor;
    };
    TranscoderController.prototype.stateAfterEvent = function (eventId) {
        var accessor = new this.stateAccessorClass(common.AccessorType.After, this);
        accessor.eventIndex = this.transcoder.outIndexMap[eventId];
        return accessor;
    };
    // not implemented
    TranscoderController.prototype.stateAfterTimestamp = function (_timestamp) {
        return new this.stateAccessorClass(common.AccessorType.After, this);
    };
    // not implemented
    TranscoderController.prototype.eventIdAfterTimestamp = function (_timestamp) {
        throw new Error('method not implemented for Transcoder');
    };
    TranscoderController.prototype.outputStream = function () {
        this.transcoder.processToLatestEvent();
        return this.transcoder.outStream;
    };
    TranscoderController.prototype.outputEventById = function (eventId) {
        return this.outputStream()[this.transcoder.outIndexMap[eventId]];
    };
    TranscoderController.prototype.outputEventsById = function (eventIds) {
        return _.map(eventIds, this.outputEventById, this);
    };
    TranscoderController.prototype.setEngineOutStreamAndIndex = function (index) {
        for (var _i = 0, _a = this.engines; _i < _a.length; _i++) {
            var engine = _a[_i];
            engine.baseEvents = this.transcoder.outStream;
            engine.rollbackToBeforeEvent(index);
        }
    };
    return TranscoderController;
}(Controller));
exports.TranscoderController = TranscoderController;
var BaseStateAccessor = /** @class */ (function () {
    function BaseStateAccessor(accessorType) {
        this.accessorType = accessorType;
        this.typeToMethodName = {
            0: 'latestState',
            1: 'stateBeforeEvent',
            2: 'stateAfterEvent',
        };
    }
    return BaseStateAccessor;
}());
exports.BaseStateAccessor = BaseStateAccessor;
var EngineStateAccessor = /** @class */ (function (_super) {
    tslib_1.__extends(EngineStateAccessor, _super);
    function EngineStateAccessor(accessorType, controller) {
        var _this = _super.call(this, accessorType) || this;
        _this.controller = controller;
        return _this;
    }
    EngineStateAccessor.prototype.get = function (property, engine) {
        return this.stateForCurrentAccessType(engine)[property];
    };
    EngineStateAccessor.prototype.call = function (method, callWithArgs, engine) {
        var _a;
        return (_a = this.stateForCurrentAccessType(engine))[method].apply(_a, callWithArgs);
    };
    EngineStateAccessor.prototype.stateForCurrentAccessType = function (engine) {
        if (this.accessorType === common.AccessorType.Latest) {
            return engine[this.typeToMethodName[this.accessorType]];
        }
        else {
            var state = engine[this.typeToMethodName[this.accessorType]](this.eventIndex);
            if (state === undefined) {
                throw new InvalidEventIndexError(this.eventIndex);
            }
            return state;
        }
    };
    return EngineStateAccessor;
}(BaseStateAccessor));
exports.EngineStateAccessor = EngineStateAccessor;
function findEventBinarySearch(arr, timestamp) {
    var start = 0;
    var end = arr.length - 1;
    while (start <= end) {
        var mid = Math.floor((start + end) / 2);
        var before = arr[mid - 1];
        if (before) {
            if (arr[mid].createdAt > timestamp && before.createdAt <= timestamp) {
                return before;
            }
        }
        else {
            return arr[mid];
        }
        var midCreatedAt = arr[mid].createdAt;
        if (midCreatedAt && timestamp < midCreatedAt) {
            end = mid - 1;
        }
        else {
            start = mid + 1;
        }
    }
    return arr[arr.length - 1];
}
//# sourceMappingURL=controller.js.map